import React, { useCallback, useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-papi-types';
import { Url } from '@wix/da-url';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import { ResourceType } from '@wix/da-shared-react/pkg/types/resource';
import ConditionalWrapper from '@wix/da-shared-react/pkg/ConditionalWrapper';

import s from './TierBanner.scss';

export interface Props {
  className?: string;
  show: boolean;
  profileOwnerUser: PapiUser;
}

export const TierBanner: React.FC<Props> = ({
  show,
  profileOwnerUser,
  className,
}) => {
  const { t } = useTranslation();
  const { username, userId } = profileOwnerUser;
  const isMobile = useContext(MobileContext);
  const subscribe = useCallback(() => {
    window.location.href = Url.userSubscriptionsPath({
      username,
    });
  }, [username]);

  if (!show) {
    return null;
  }
  return (
    <div className={classnames(s['root'], s['ms-ads-mobile'], className)}>
      <div className={s['container']}>
        <ConditionalWrapper
          condition={isMobile}
          wrap={child => (
            <BiLink
              className={s['link']}
              onClick={subscribe}
              biData={{
                evid: BiEventType.VIEW_SUBSCRIPTION_TAB,
                typeid: ResourceType.USER,
                itemid: userId,
                referral_info: ReferralType.PROFILE_COVER_PROMOTION,
              }}
            >
              {child}
            </BiLink>
          )}
        >
          <div className={s['body']}>
            {t('common.profileHero.tierBanner.body.offerTiers')}
          </div>
          {!isMobile && (
            <BiLink
              className={s['link']}
              onClick={subscribe}
              biData={{
                evid: BiEventType.VIEW_SUBSCRIPTION_TAB,
                typeid: ResourceType.USER,
                itemid: userId,
                referral_info: ReferralType.PROFILE_COVER_PROMOTION,
              }}
            >
              {t('common.profileHero.tierBanner.link.subscribe')}
            </BiLink>
          )}
        </ConditionalWrapper>
      </div>
    </div>
  );
};
TierBanner.displayName = 'TierBanner';

export default TierBanner;
